import React from 'react';
import { Layout } from '../components/layout/Layout';
import { CONTACT } from '../data/siteData';
import { useSEO } from '../hooks/useSEO';

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-xl font-semibold text-[#0A192F] font-heading mb-3">{title}</h2>
    <div className="text-sm text-slate-600 leading-relaxed space-y-3">{children}</div>
  </div>
);

export const LegalShell = ({ title, updated, children }) => (
  <Layout>
    <section className="pt-32 pb-16 bg-[#0A192F]">
      <div className="max-w-3xl mx-auto px-6">
        <h1 className="text-3xl md:text-4xl font-semibold text-white font-heading">{title}</h1>
        <p className="text-sm text-slate-400 mt-3">Last updated: {updated}</p>
      </div>
    </section>
    <section className="py-16 bg-white">
      <div className="max-w-3xl mx-auto px-6">{children}</div>
    </section>
  </Layout>
);

export default function PrivacyPolicy() {
  useSEO('Privacy Policy | WorkLynx');
  return (
    <LegalShell title="Privacy Policy" updated="June 2026">
      <Section title="1. Information We Collect">
        <p>When you use our website or submit our contact forms, we may collect your name, company name, email address, phone number, service interest, preferred call time and any requirement details you share with us.</p>
      </Section>
      <Section title="2. How We Use Your Information">
        <p>We use the information you provide to respond to your enquiries, prepare workforce proposals, schedule consultations, and communicate about our services. We do not sell your personal information to third parties.</p>
      </Section>
      <Section title="3. Data Storage & Security">
        <p>Your data is stored securely and access is restricted to authorized WorkLynx personnel. We apply reasonable technical and organizational safeguards to protect it against unauthorized access, alteration or disclosure.</p>
      </Section>
      <Section title="4. Cookies & Analytics">
        <p>Our website may use cookies and analytics tools to understand usage patterns and improve user experience. You can control cookies through your browser settings.</p>
      </Section>
      <Section title="5. Third-Party Services">
        <p>We use trusted third-party services such as scheduling tools (Calendly) and communication platforms (WhatsApp, email). Their use of your data is governed by their respective privacy policies.</p>
      </Section>
      <Section title="6. Your Rights">
        <p>You may request access to, correction of, or deletion of your personal data by writing to us at {CONTACT.email}.</p>
      </Section>
      <Section title="7. Contact Us">
        <p>For any privacy-related questions, contact us at {CONTACT.email} or call {CONTACT.phone}. Corporate Office: {CONTACT.corporateOffice}.</p>
      </Section>
    </LegalShell>
  );
}
